import React, { useCallback, useState } from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { uniqBy } from 'lodash-es';

import { ConfirmationModal } from 'shared/components/ConfirmationModal';
import { BlankSafelist, SafelistTerm } from 'shared/types/safelist';
import { addSafelist } from 'services/safelists/actions';
import { getIsAddingSafelistFlag } from 'services/safelists/getters';

import { SafelistDetailView } from '../SafelistDetailView';
import { filterRepeatedTerms } from '../utils';

const ADD_SAFELIST_MODAL = 'add-safelist-modal';

const StyledSafelistDetailView = styled(SafelistDetailView)`
  height: 100%;
`;

const AddSafelistModal = () => {
  const dispatch = useDispatch();
  const [safelist, setSafelist] = useState<BlankSafelist>({});
  const isAddingSafelist = useSelector(getIsAddingSafelistFlag);

  const updateSafelist = (key: string, value: any) => {
    const updatedSafelist = {
      ...safelist,
      [key]: value,
    };

    setSafelist(updatedSafelist);
  };

  const handleTermAdding = (terms: SafelistTerm[]) => {
    const newTerms = (safelist.terms || []).concat(terms);
    const uniqueTerms =  filterRepeatedTerms(newTerms);

    updateSafelist('terms', uniqueTerms);
  };

  const handleTermDeletion = (termToDelete: SafelistTerm) => {
    const updatedTerms = safelist.terms?.filter((term) => term.entity !== termToDelete.entity);

    updateSafelist('terms', updatedTerms);
  };

  const onSubmit = () => {
    dispatch(addSafelist(safelist));
  };

  const onModalClose = useCallback(() => {
    setSafelist({})
  }, []);

  return (
    <ConfirmationModal
      name={ADD_SAFELIST_MODAL}
      title='Add Safelist Library'
      submitButtonLabel='Add Safelist Library'
      isSubmitting={isAddingSafelist}
      onSubmit={onSubmit}
      onClose={onModalClose}
      isSubmitButtonDisabled={!safelist.name}
    >
      <StyledSafelistDetailView
        safelistName={safelist.name}
        terms={safelist.terms}
        onChangeName={(newSafelistName: string) => updateSafelist('name', newSafelistName)}
        onDeleteTerm={handleTermDeletion}
        onAddTerms={handleTermAdding}
      />
    </ConfirmationModal>
  );
};

export {
  AddSafelistModal,
  ADD_SAFELIST_MODAL,
};
